import React from 'react'
import { Link } from 'react-router-dom'

export default function AboutSection({mtop} ) {
  return (
    <div id='about-home'  className='about-home' style={{marginTop : `${mtop}rem` }} >
     <div className="abs-bg"></div>
    <div className="description-grid">
      <h3 className='' data-aos="fade-right">About Nabaki.</h3>
      <div className='description-0' >
        <p data-aos="fade-up">
        Through a unique combination of engineering, construction, and design<br/>
        disciplines and expertise, Nabaki Africa delivers world-class infrastructure<br/>
        solutions to customers and stakeholders across a broad range of industry<br/>
        sectors.
        <br/><br/>
        We leverage this competence and expertise to deliver major projects in<br/>
        rural and urban settings, as well as high-growth in markets of developing<br/>
        economies.  
        </p>
        <Link className='qoute-btn text-body text-decoration-none' to='/contact' data-aos="zoom-in" data-aos-delay='200' >Get a quote</Link>
      </div>
    </div>
  </div>
  )
}
